import { Injectable } from '@angular/core';
import { GlobeService } from './globe.service';
import { BaseMapEntity } from './base-map-entity.service';
import { DataContextService } from './data-context.service';
import { CoreService } from './core.service';
import { CameraService } from './camera.service';
import { WindowService } from './window.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TimelineService } from './timeline.service';

import * as Cesium from 'cesium';

@Injectable({
  providedIn: 'root',
})
export class KmlService {
  constructor(
    private globeService: GlobeService,
    private dataContext: DataContextService,
    private cameraService: CameraService,
    private coreService: CoreService,
    private windowService: WindowService,
    private modalService: NgbModal,
    private timelineService: TimelineService
  ) {}

  async loadKML(kmlUrl: any, folder?: string): Promise<void> {
    const viewer = this.globeService.getViewer();
    if (!viewer) {
      throw new Error('Cesium viewer not initialized');
    }

    const dataSource = await Cesium.KmlDataSource.load(kmlUrl);
    viewer.dataSources.add(dataSource);

    const entities = dataSource.entities.values;
    const layer = 'KML';

    for (const entity of entities) {
      const baseMapEntity = new BaseMapEntity(
        entity.name || 'KML Entity',
        folder ? `KML//${folder}` : layer,
        this.cameraService,
        this.coreService,
        this.windowService,
        this.dataContext, this.modalService, this.timelineService
      );
      baseMapEntity.cesiumEntity = entity;
      (entity as any).arcLiveMapEntity = baseMapEntity;
      this.dataContext.addMapEntity(baseMapEntity);
    }
  }
}
